import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import type { BundleItem } from '../../../../stores/rewards/types';
import { formatValueWithK } from '../../../../utils/helpers';
import { BundleItemsRenderer } from '../../../BundleItemsRenderer/BundleItemsRenderer';
import { SocialCoin } from '../../../SocialCoin/SocialCoin';
import { SweepCoin } from '../../../SweepCoin/SweepCoin';

import styles from './PromoRewardsDisplay.module.scss';

type PromoRewardsDisplayProps = {
  gcAmount?: number;
  scAmount?: number;
  bundleItems?: BundleItem[] | null;
  className?: string;
};

export function PromoRewardsDisplay({ gcAmount = 0, scAmount = 0, bundleItems, className }: PromoRewardsDisplayProps) {
  const { t } = useTranslation();
  const hasCoins = gcAmount > 0 || scAmount > 0;
  const hasBundleItems = bundleItems && bundleItems.length > 0;
  const hasBothCoins = gcAmount > 0 && scAmount > 0;

  return (
    <div className={classNames(styles.promoRewardsDisplay, className)}>
      {hasCoins && (
        <div className={styles.coinsFrame}>
          <div className={styles.coinsContent}>
            {gcAmount > 0 && (
              <div className={styles.coinAmount} data-testid="promotion-gift-gc-amount">
                <SocialCoin alt="Crown Coins" className={styles.coinIcon} />
                <span className={styles.coinValue}>{formatValueWithK(gcAmount, t)}</span>
              </div>
            )}
            {hasBothCoins && <span className={styles.coinPlus}>+</span>}
            {scAmount > 0 && (
              <div className={styles.coinAmount} data-testid="promotion-gift-sc-amount">
                <SweepCoin alt="Sweepstakes Coins" className={styles.coinIcon} />
                <span className={styles.coinValue}>{scAmount.toLocaleString()}</span>
              </div>
            )}
          </div>
          {hasBundleItems && <div className={styles.plusSeparator}>+</div>}
        </div>
      )}

      {hasBundleItems && (
        <>
          <div className={styles.bundleItemsWrapper}>
            <BundleItemsRenderer
              hidePlus
              bundleItems={bundleItems}
              className={styles.bundleItem}
              dataTestId="promotion-gift-bundle-items"
              direction="vertical-v2"
              frbWidgetWidth={bundleItems.length === 1 ? 130 : 90}
              metagameIconClassName={styles.metagameIcon}
              metagameTextClassName={styles.metagameText}
              metagameTextContainerClassName={styles.metagameTextContainer}
              metaGameWidgetWidth={bundleItems.length === 1 ? 130 : 90}
            />
          </div>
        </>
      )}
    </div>
  );
}
